const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['kudos', [this, 'block_kudos']],
                    ['legal', [this, 'block_legal']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.startOutputBuffer();
                this.echo(`  `);
                this.traceableDisplayBlock(2, this.source)('kudos', context.clone(), blocks);
                context.proxy[`kudos`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
`);
                this.startOutputBuffer();
                this.echo(`  `);
                this.traceableDisplayBlock(6, this.source)('legal', context.clone(), blocks);
                context.proxy[`legal`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
<footer class="c-ground-nav">
  `);
                if ((context.has(`action`) ? context.get(`action`) : null)) {
                    this.echo(`    `);
                    let __internal_480b6d2e4b70b4ccce4936e035b2ead64f8213fee7b9a90a92d1f2d0fee68eaa = (((context.has(`action`))) ? (this.env.getFilter('default').traceableCallable(15, this.source)(...[(context.has(`action`) ? context.get(`action`) : null), new Map([])])) : (new Map([])));
                    if (typeof (__internal_480b6d2e4b70b4ccce4936e035b2ead64f8213fee7b9a90a92d1f2d0fee68eaa) !== 'object') {
                        throw new this.RuntimeError('Variables passed to the "with" tag must be a hash.', 15, this.source);
                    }
                    context.set('_parent', context.clone());
                    context = new this.Context(this.env.mergeGlobals(this.merge(context, this.convertToMap(__internal_480b6d2e4b70b4ccce4936e035b2ead64f8213fee7b9a90a92d1f2d0fee68eaa))));
                    this.echo(`      <div class="c-ground-nav__action o-container o-container--pad-inline">
        <div class="o-container__content c-ground-nav__action-inner">
          <h2 class="c-ground-nav__action-lead-in">
            `);
                    this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, (context.has(`lead_in`) ? context.get(`lead_in`) : null), `html`, null, true]));
                    this.echo(`
          </h2>
          <p class="c-ground-nav__action-title">
            `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`href`, (context.has(`link`) ? context.get(`link`) : null)], [`label`, (context.has(`title`) ? context.get(`title`) : null)], [`content_start_icon`, ((!!((context.has(`icon`)) &&  !this.env.getTest('null').traceableCallable(25, this.source)(...[context.get(`icon`)]))) ? (context.get(`icon`)) : (`link`))]]), false, false, 22));
                    this.echo(`          </p>
          `);
                    this.echo(this.include(context, this.source, `@cloudfour/assets/illustrations/portland.svg.twig`, new Map([[`class`, `c-ground-nav__action-illustration`]]), true, false, 28));
                    this.echo(`        </div>
      </div>
    `);
                    context = context.get('_parent');
                    this.echo(`  `);
                }
                this.echo(`
  <div class="c-ground-nav__content o-container o-container--pad t-alternate">
    <div class="c-ground-nav__content-inner o-container__content">
      <h2 class="u-hidden-visually">
        Contact info
      </h2>
      `);
                this.echo(`      `);
                let __internal_33edd7af866d6558b71210ef6a8e41e625f7bc78fe5773029da2505a5cb7c3bf = (((context.has(`organization`))) ? (this.env.getFilter('default').traceableCallable(42, this.source)(...[(context.has(`organization`) ? context.get(`organization`) : null), new Map([])])) : (new Map([])));
                if (typeof (__internal_33edd7af866d6558b71210ef6a8e41e625f7bc78fe5773029da2505a5cb7c3bf) !== 'object') {
                    throw new this.RuntimeError('Variables passed to the "with" tag must be a hash.', 42, this.source);
                }
                context.set('_parent', context.clone());
                context = new this.Context(this.env.mergeGlobals(this.merge(context, this.convertToMap(__internal_33edd7af866d6558b71210ef6a8e41e625f7bc78fe5773029da2505a5cb7c3bf))));
                this.echo(`        <address class="c-ground-nav__organization">
          <a href="`);
                this.echo(this.env.getFilter('escape').traceableCallable(44, this.source)(...[this.env, (context.has(`url`) ? context.get(`url`) : null), `html`, null, true]));
                this.echo(`" class="c-ground-nav__organization-name">
            `);
                this.echo(this.env.getFilter('escape').traceableCallable(45, this.source)(...[this.env, (context.has(`name`) ? context.get(`name`) : null), `html`, null, true]));
                this.echo(`
          </a><br>
          `);
                let __internal_19a115f5ef10175a49f168122c42e77f734406fb996dde502b939486cd6b9e5d = (((context.has(`address`))) ? (this.env.getFilter('default').traceableCallable(47, this.source)(...[(context.has(`address`) ? context.get(`address`) : null), new Map([])])) : (new Map([])));
                if (typeof (__internal_19a115f5ef10175a49f168122c42e77f734406fb996dde502b939486cd6b9e5d) !== 'object') {
                    throw new this.RuntimeError('Variables passed to the "with" tag must be a hash.', 47, this.source);
                }
                context.set('_parent', context.clone());
                context = new this.Context(this.env.mergeGlobals(this.merge(context, this.convertToMap(__internal_19a115f5ef10175a49f168122c42e77f734406fb996dde502b939486cd6b9e5d))));
                this.echo(`            `);
                this.echo(this.env.getFilter('escape').traceableCallable(48, this.source)(...[this.env, (context.has(`street_address`) ? context.get(`street_address`) : null), `html`, null, true]));
                this.echo(`<br>
            `);
                this.echo(this.env.getFilter('escape').traceableCallable(49, this.source)(...[this.env, (context.has(`address_locality`) ? context.get(`address_locality`) : null), `html`, null, true]));
                this.echo(`, `);
                this.echo(this.env.getFilter('escape').traceableCallable(49, this.source)(...[this.env, (context.has(`address_region`) ? context.get(`address_region`) : null), `html`, null, true]));
                this.echo(` `);
                this.echo(this.env.getFilter('escape').traceableCallable(49, this.source)(...[this.env, (context.has(`postal_code`) ? context.get(`postal_code`) : null), `html`, null, true]));
                this.echo(` `);
                this.echo(this.env.getFilter('escape').traceableCallable(49, this.source)(...[this.env, (context.has(`address_country`) ? context.get(`address_country`) : null), `html`, null, true]));
                this.echo(`<br>
          `);
                context = context.get('_parent');
                this.echo(`          <a href="mailto:`);
                this.echo(this.env.getFilter('escape').traceableCallable(51, this.source)(...[this.env, (context.has(`email`) ? context.get(`email`) : null), `html`, null, true]));
                this.echo(`">`);
                this.echo(this.env.getFilter('escape').traceableCallable(51, this.source)(...[this.env, (context.has(`email`) ? context.get(`email`) : null), `html`, null, true]));
                this.echo(`</a><br>
          `);
                this.echo(`          <a href="tel:`);
                this.echo(this.env.getFilter('escape').traceableCallable(53, this.source)(...[this.env, this.env.getFilter('replace').traceableCallable(53, this.source)(...[(context.has(`telephone`) ? context.get(`telephone`) : null), new Map([[`.`, `-`], [`(`, `-`], [`)`, `-`], [` `, ``]])]), `html`, null, true]));
                this.echo(`">`);
                this.echo(this.env.getFilter('escape').traceableCallable(58, this.source)(...[this.env, (context.has(`telephone`) ? context.get(`telephone`) : null), `html`, null, true]));
                this.echo(`</a>
        </address>
      `);
                context = context.get('_parent');
                this.echo(`      `);
                this.echo(`      <div class="c-ground-nav__social">
        <ul class="c-ground-nav__social-list o-list o-list--inline" role="list">
          `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.traceableMethod(this.getAttribute, 64, this.source)(this.env, (context.has(`social`) ? context.get(`social`) : null), `items`, new Map([]), `any`, false, false, false));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`item`] = __value__;
                    this.echo(`            <li class="c-ground-nav__social-item">
              <a class="c-ground-nav__social-action" href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(66, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 66, this.source)(this.env, context.get(`item`), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`">
                `);
                    this.echo(`                <span class="u-hidden-visually">`);
                    this.echo(this.env.getFilter('escape').traceableCallable(68, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 68, this.source)(this.env, context.get(`item`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`</span>
                `);
                    this.echo(`                `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, this.traceableMethod(this.getAttribute, 71, this.source)(this.env, context.get(`item`), `icon`, new Map([]), `any`, false, false, false)], [`fallback`, `link`], [`focusable`, `false`], [`class`, `c-ground-nav__social-icon`]]), false, false, 70));
                    this.echo(`              </a>
            </li>
          `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('item');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`        </ul>
      </div>

      <nav class="c-ground-nav__menu" aria-labelledby="footer-menu-label">
        <h2 id="footer-menu-label" class="u-hidden-visually">
          Extended Menu
        </h2>
        `);
                this.echo(`        <ul class="c-ground-nav__menu-items o-list" role="list">
          `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.traceableMethod(this.getAttribute, 88, this.source)(this.env, (context.has(`menu`) ? context.get(`menu`) : null), `items`, new Map([]), `any`, false, false, false));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`item`] = __value__;
                    this.echo(`            <li class="c-ground-nav__menu-item">
              <a class="c-ground-nav__menu-action"
                href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(91, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 91, this.source)(this.env, context.get(`item`), `link`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`"
                `);
                    if (this.traceableMethod(this.getAttribute, 92, this.source)(this.env, context.get(`item`), `current`, new Map([]), `any`, false, false, false)) {
                        this.echo(`                  aria-current="page"
                `);
                    }
                    this.echo(`>
                `);
                    this.echo(this.env.getFilter('escape').traceableCallable(95, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 95, this.source)(this.env, context.get(`item`), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`
              </a>
            </li>
          `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('item');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`        </ul>
      </nav>

      `);
                if ((context.has(`kudos`) ? context.get(`kudos`) : null)) {
                    this.echo(`        `);
                    this.echo(this.env.getFilter('escape').traceableCallable(103, this.source)(...[this.env, (context.has(`kudos`) ? context.get(`kudos`) : null), `html`, null, true]));
                    this.echo(`
      `);
                }
                this.echo(`
      `);
                if ((context.has(`legal`) ? context.get(`legal`) : null)) {
                    this.echo(`        `);
                    this.echo(this.env.getFilter('escape').traceableCallable(107, this.source)(...[this.env, (context.has(`legal`) ? context.get(`legal`) : null), `html`, null, true]));
                    this.echo(`
      `);
                }
                this.echo(`
    </div>
  </div>
</footer>
`);
            }

            block_kudos(context, blocks = new Map()) {
                let macros = this.macros.clone();
            }

            block_legal(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p class="c-ground-nav__legal">
      © `);
                this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(8, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 8, this.source)(this.env, (context.has(`organization`) ? context.get(`organization`) : null), `founding_date`, new Map([]), `any`, false, false, false), `Y`]), `html`, null, true]));
                this.echo(`–`);
                this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, this.env.getFilter('date').traceableCallable(8, this.source)(...[this.env, `now`, `Y`]), `html`, null, true]));
                this.echo(` `);
                this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 8, this.source)(this.env, (context.has(`organization`) ? context.get(`organization`) : null), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`
    </p>
  `);
            }

            getTemplateName() {
                return `dbc44ecd2fe6120a984917f517e86cbd06d0e129283fc1381216fa3b69c96b35`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `dbc44ecd2fe6120a984917f517e86cbd06d0e129283fc1381216fa3b69c96b35`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'dbc44ecd2fe6120a984917f517e86cbd06d0e129283fc1381216fa3b69c96b35');

let template = env.loadTemplate('dbc44ecd2fe6120a984917f517e86cbd06d0e129283fc1381216fa3b69c96b35');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/ground-nav/ground-nav.twig", args: context }
     );
     return rendered;;
};